import Copy from './copy';

export default Copy;
